import React from 'react';

const Logo = ({ className = 'w-10 h-10' }) => (
  <img
    src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1767386168093-image.png"
    alt="Valtivo Logo"
    className={`${className} object-contain`}
  />
);

export default Logo;